export enum StatisticsFetchType {
  PostPeopleCount = 'PostPeopleCount',
  PostCount = 'PostCount',
  LandingPeopleCount = 'LandingPeopleCount',
  LandingRate = 'LandingRate',
  PostingRate = 'PostingRate',
  PostContentTagTypePercentage = 'PostContentTagTypePercentage',
  PostContentTagTypeTrend = 'PostContentTagTypeTrend',
}

export const TimeRange = {
  year: '年',
  month: '月',
  //  week: '周',
  date: '日期',
} as const
export type TimeRangeType = keyof typeof TimeRange
